
<template>
    <div>
        <!-- 新闻 -->
        <div class='news'>
            <HomeCard class="wrap" title="新闻中心" desc='CENTER OF NEWS' img='../../assets/icon1.png' v-bind:link='{to:"/news",name:"查看更多新闻"}'>
                <div v-if="news && news.length > 0" class="news-content bg_grey d_f jc_sb">
                    <img :src="news[0] ? news[0].newsPicUrl : '' " alt="">
                    <div class="news-list">
                        <a :href="'/#/news/details/?id='+item.id" v-for="item in news" :key="item.id" class="d_f jc_sb c_black news-item">
                            <span>{{item.title}}</span>
                            <span>{{item.createTime}}</span>
                        </a>
                    </div>
                </div>
                <a-result v-else status="warning" title="暂时没有数据哟" />
            </HomeCard>
        </div>
        <!-- 资质 -->
        <div class="qualifications product">
            <HomeCard class="wrap" title="资质" desc='Qualifications' img='../../assets/icon1.png'>
                <div v-if="qualifications && qualifications.length > 0" class="product-content">
                    <ScrollList :postMain='true' :list='qualifications'/>
                </div>
                <a-result v-else status="warning" title="暂时没有数据哟" />
            </HomeCard>
        </div>

        <!-- 案例 -->
        <div class="case">
            <HomeCard class="wrap" title="工程案例" desc='ENGINEERING CASE' :titleStyle='true' img='../../assets/icon2.png'>
                <div class="case-content" v-if="cases && cases.length > 0">
                    <swiper ref="mySwiper" :options="p_swiperOptions" class="swiper">

                        <swiper-slide v-for="item in cases" :key="item.id" class="c_white swiper-item d_f jc_sb">
                            <img :src="item.projectPicUrl" alt="">
                            <div class="swiper-item-desc">
                                <h2 class="P_xxl c_white">{{item.title}}</h2>
                                <span class="P_x c_white">ROAD SIGN ENGINEERING</span>
                                <p>{{item.contents}}</p>
                                <router-link :to="'/case/details?id='+item.id" class="d_f ai_c c_white">查看更多<img src="../../assets/jt-w.png" alt=""></router-link>
                            </div>
                        </swiper-slide>

                        <div class="swiper-state" id="parent" slot="pagination"></div>
                    </swiper>
                    <div class="jt-left"><img src="../../assets/jt-left.png" alt=""></div>
                    <div class="jt-right"><img src="../../assets/jt-right.png" alt=""></div>
                </div>
                <a-result v-else status="404" title="" sub-title="暂时没有数据哟" />
            </HomeCard>
        </div>

        <!-- 产品 -->
        <div class="product">
            <HomeCard class="wrap" title="产品推荐" desc='RECOMMONDATION' img='../../assets/icon1.png' v-bind:link='{to:"/product",name:"查看更多产品"}'>
                <div v-if="products && products.length > 0" class="product-content">
                    <ScrollList :list='products'/>
                </div>
                <a-result v-else status="404" title="暂时没有数据哟" />
            </HomeCard>
        </div>

        <!-- 简介 -->
        <div class="about bg_grey">

            <div class="wrap h_1">
                <div class="about-wrap d_f h_1">
                    <div class="about-item">
                        <HomeCard class="w_1" title="公司简介" desc='brief introduction' img='../../assets/icon1.png'>
                            <div v-if="about && about.name && about.profile" class="about-content">
                                <h2 class="P_xxl">{{about.name}}</h2>
                                <p class="P_l">
                                    {{about.profile}}
                                </p>
                                <router-link to="/about" class="c_black d_b">
                                    了解更多 >
                                </router-link>
                            </div>
                            <a-result v-else status="403" title="暂时没有数据哟" />
                        </HomeCard>
                    </div>
                    <div class="about-bg">
                        <img src="../../assets/stained.png" alt="">
                    </div>
                </div>
            </div>

        </div>

        <!-- 产品追溯介绍 -->
        <div class="introduce">
            <div class="wrap d_f ">
                <HomeCard class="introduce-item" title="产品追溯介绍" desc='' img='../../assets/icon1.png'>
                    <div class="introduce-content">
                        <p>
                            使用手机打开二维码扫描，对准产品右下角二维码进行扫码，可查询该产品的数据信息，参数等。
                        </p>
                    </div>
                </HomeCard>
                <div class="bz-bg">
                    <img src="../../assets/bz.png" alt="">
                </div>
            </div>
        </div>

    </div>
</template>



<script>

import HomeCard from '../../components/Home-card/index';
import ScrollList from '../../components/Scroll-list'
import index from './index'
export default {
    ...index,
    components : {
        HomeCard,
        ScrollList
    },
    methods : {
        
    }
}
</script>


<style lang="scss" scoped>
/* 新闻 */
    .news{
        margin:50px 0;
        .news-content{
            height: 350px;
            padding: 32.5px;
            img{
                width: 424px;
                height: 285px;
                margin-right: 20px;
            }
            .news-list{
                flex : 1;
                .news-item{
                    line-height: 56px;
                    border-bottom: 1px solid #ccc;
                }
            }
        }
    }
    .wrap{
        width: 1200px;
        margin: auto;
    }
/* 案例 */
    .case{
        height: 762px;
        width: 100%;
        background: url('../../assets/al-bg.png') no-repeat center;
        margin-bottom: 100px;
        .wrap{
            padding: 60px 0 0;
            .case-content{
                position: relative;
                height: 610px;

                .swiper{
                    position: relative;
                    height: 100%;
                    .swiper-state{
                        position: absolute;
                        bottom: 50px !important;
                        height: 17px;
                        text-align: center;
                        z-index: 5;
                    }
                    // #parent /deep/ .swiper-pagination-bullet{
                    //     width: 17px !important;
                    //     height: 17px !important;
                    //     background-color: #fff;
                    //     border-radius: 0;
                    //     margin: 0 10px !important;
                    // }
                    .swiper-item{
                        padding: 50px 100px 150px;
                        box-sizing: border-box;;
                        img{
                            height: 410px;
                            width: 410px;
                        }
                        .swiper-item-desc{
                            width: 437px;
                            height: 410px;
                            padding-top: 100px;
                            h2{
                                margin: 0 !important;
                                overflow:hidden;
                                white-space: nowrap;
                                text-overflow:ellipsis;
                            }
                            span{
                                display: block;
                                padding-bottom: 25px;
                                border-bottom: 1px solid #fff;
                            }
                            p{
                                margin: 10px 0;
                                height: 158px;
                                display:-webkit-box;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                -webkit-line-clamp:7;
                                -webkit-box-orient:vertical;
                            }
                            a{
                                text-align: right;
                                justify-content: flex-end;
                                img{
                                    width: 16px;
                                    height: 16px;
                                    margin-left: 5px;
                                }
                            }
                        }
                    }
                }
                .jt-left,.jt-right{
                    position: absolute;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 38px;
                    height: 95px;
                    background-color: rgba(255,255,255,.5);
                    z-index: 99;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .jt-right{
                    right: 0;
                }
            }
        }
    }

/* 产品 */
    .product{
        margin-bottom: 100px;
        .product-content{
            height: 406px;
        }
    }

/* 简介 */
    .about{
        height: 865px;
        overflow-X: hidden;
        overflow-y: hidden;
        .about-wrap{
            .about-item,.about-bg{
                width: 600px;
                height: 100%;
            }
            .about-item{
                padding: 85px 40px 85px 0;
                .about-content{
                    h2{
                        width: 423px;
                        margin: 50px 0;
                    }
                    p{
                        line-height: 43px;
                        font-family: "PingFangSC-Light";
                        display: -webkit-box;
                        overflow: hidden;
                        text-overflow: -o-ellipsis-lastline;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 8;
                        -webkit-box-orient: vertical;
                    }
                    a{
                        padding: 10px 0;
                        width: 150px;
                        border: 1px solid #ccc;
                        text-align: center;
                        margin-top: 50px;
                    }
                }
            }
        }
    }

/* 产品追溯介绍 */
    .introduce{
        height: 512px;
        .wrap{
            padding: 100px 0;
            height: 100%;
            .introduce-item{
                width: 600px;
                padding-right: 100px;
            }
            .bz-bg{
                width: 600px;
                height: 100%;
                background:url(../../assets/bz-bg.png) no-repeat center;
                text-align: center;
                img{
                    height: 100%;
                }
            }
        }
    }
</style>